<template>
  <div>
    <template v-if="'credit_card_online' === payment.type || 'credit_card_off_session' === payment.type">
      <v-row justify="center" class="mt-5">
        <v-icon size="128" color="green">mdi-check-circle-outline</v-icon>
      </v-row>
      <v-row justify="center" class="mb-5">
        <div class="headline">
          {{ $t('message.your_payment_has_been_processed_correctly') }}
        </div>
      </v-row>
    </template>
    <template v-else>
      <v-row justify="center" class="mt-5">
        <v-icon size="128" color="green">mdi-check-circle-outline</v-icon>
      </v-row>
      <v-row justify="center" class="mb-5">
        <div class="headline">
          {{ $t('message.your_request_has_been_processed_correctly') }}
        </div>
      </v-row>
    </template>

    <template v-if="'transfer' === payment.type">
      <div class="title mb-3">
        {{ $t('message.how_do_i_make_the_payment') }}
      </div>
      <PaymentTransferInstructions :payment="payment" :final-price="payment.parentOrder.grossTotal" />
    </template>

    <div
      v-if="'direct_debit' === payment.type"
      class="subheading text-center"
      v-html="
        $t('message.direct_debit_iban_info', {
          iban: ofuscateIban(payment.parentOrder.agreement.legalEntity.iban)
        })
      "
    ></div>

    <div v-if="'airtime_balance' === payment.type" class="subheading text-center">
      {{ $t('message.balance_used') }}
    </div>
  </div>
</template>

<script>
import PaymentTransferInstructions from '../PaymentTransferInstructions'
import { ofuscateIban } from '@/utils/string'

export default {
  components: {
    PaymentTransferInstructions
  },
  props: {
    payment: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      ofuscateIban: ofuscateIban
    }
  }
}
</script>
